import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { PlayerAuthProvider } from "./context/PlayerAuthContext";
import { getSafeRouterBasename } from "./lib/routerBasename";
import { consumePlayerUrlToken } from "./lib/urlToken";
import "./styles/variables.css";
import "./styles/index.css";

const urlToken = typeof window !== "undefined" ? consumePlayerUrlToken() : null;

const rootEl = document.getElementById("lesson-player-root");
if (rootEl) {
  const basename = getSafeRouterBasename();
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <BrowserRouter basename={basename}>
        <PlayerAuthProvider initialUrlToken={urlToken}>
          <App />
        </PlayerAuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
} else if (typeof window !== "undefined") {
  console.error(
    "[Lesson Player] No #lesson-player-root element — add <div id=\"lesson-player-root\"></div> where the app should mount."
  );
  const banner = document.createElement("div");
  banner.setAttribute("role", "alert");
  banner.style.cssText =
    "box-sizing:border-box;padding:16px 20px;margin:24px auto;max-width:42rem;font:14px/1.5 system-ui,-apple-system,sans-serif;color:#7f1d1d;background:#fef2f2;border:2px solid #ef4444;border-radius:8px;";
  banner.innerHTML =
    "<strong>Lesson Player:</strong> this page is missing <code>&lt;div id=&quot;lesson-player-root&quot;&gt;&lt;/div&gt;</code>. Add it to your WordPress / course template, then reload.";
  document.body.appendChild(banner);
}
